/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import CustomButtom from '../../components/CustomButtons/ButtonExt';
import I18n from '../../components/Translate/I18n';

function CancelTextButton({ ...props }) {
    const { callback, callbackParam, size } = props;
    return (
        <CustomButtom size={size} onClick={() => callback(callbackParam)}>
            <I18n trans="general:common.cancel" />
        </CustomButtom>
    );
}

CancelTextButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object,
    size: PropTypes.string,
};

export default CancelTextButton;
